/*
 * Sad Friends Ceramics - Main JavaScript
 * For use in Shopify theme assets
 */

// ========================================
// 🎛️ ANIMATION CONFIGURATION
// ========================================
const ANIMATION_CONFIG = {
    // Set to false to disable loading screen and teeter animations
    // Logo will appear instantly in final position
    enableAnimations: false,  // ← Change to false to disable
    
    // Individual animation controls (only work if enableAnimations is true)
    enableLoadingScreen: true,   // Black loading screen
    enableTeeterAnimation: true, // Teeter and roll animation
    
    // Timing (in milliseconds)
    loadingDuration: 1500,       // How long loading screen shows
    animationDuration: 3000      // How long teeter-roll takes
};
// ========================================

// Check if we're on the homepage - WITH DEBUGGING
function isHomepage() {
    const path = window.location.pathname;
    const bodyClasses = document.body.className;
    
    // Debug logging - check browser console to see what's detected
    console.log('🔍 Homepage Detection:');
    console.log('   Path:', path);
    console.log('   Body classes:', bodyClasses);
    
    // Check multiple conditions
    const isRootPath = path === '/' || path === '/index' || path === '/index.html';
    const endsWithSlash = path.endsWith('/');
    const hasIndexClass = bodyClasses.includes('template-index') || bodyClasses.includes('index');
    const hasHomeClass = bodyClasses.includes('home') || bodyClasses.includes('homepage');
    
    console.log('   Is root path:', isRootPath);
    console.log('   Has template-index class:', hasIndexClass);
    console.log('   Has home class:', hasHomeClass);
    
    // If ANY of these conditions are true, it's the homepage
    const result = isRootPath || endsWithSlash || hasIndexClass || hasHomeClass;
    console.log('   ✅ HOMEPAGE DETECTED:', result);
    
    return result;
}

// Loading screen sequence (HOMEPAGE ONLY)
function initLoadingSequence() {
    const body = document.body;
    const loadingScreen = document.getElementById('loadingScreen');
    const rollingLogo = document.getElementById('rollingLogo');
    
    console.log('🎬 Starting loading sequence');
    console.log('   Loading screen element:', loadingScreen ? 'Found ✅' : 'NOT FOUND ❌');
    console.log('   Rolling logo element:', rollingLogo ? 'Found ✅' : 'NOT FOUND ❌');
    console.log('   Loading screen enabled:', ANIMATION_CONFIG.enableLoadingScreen);
    console.log('   Teeter animation enabled:', ANIMATION_CONFIG.enableTeeterAnimation);
    
    if (!loadingScreen || !rollingLogo) {
        console.error('❌ Missing required elements! Animation cannot run.');
        return;
    }
    
    // CRITICAL: Force logo to be visible on homepage
    rollingLogo.style.display = 'block';
    rollingLogo.style.visibility = 'visible';
    
    // Check if loading screen is disabled
    if (!ANIMATION_CONFIG.enableLoadingScreen) {
        console.log('⚡ Loading screen disabled - skipping');
        loadingScreen.style.display = 'none';
        body.classList.remove('loading');
        
        // Show logo and start animation (or skip to final position)
        rollingLogo.classList.add('hero-position');
        rollingLogo.style.opacity = '1';
        
        if (ANIMATION_CONFIG.enableTeeterAnimation) {
            startDropAndBounce();
        } else {
            console.log('⚡ Teeter animation disabled - showing final position');
            rollingLogo.classList.remove('hero-position');
            rollingLogo.classList.add('scrolled-position');
            initScrollBehavior();
        }
        return;
    }
    
    // Start with loading state
    body.classList.add('loading');
    
    // Hide the rolling logo during loading (we show it in the loading screen)
    rollingLogo.style.opacity = '0';
    
    console.log('⏳ Loading screen active for ' + ANIMATION_CONFIG.loadingDuration + 'ms...');
    
    // After configured duration, fade out loading screen and show content
    setTimeout(() => {
        console.log('✅ Loading complete, showing content');
        
        // Hide loading screen
        loadingScreen.classList.add('hidden');
        
        // Show content
        body.classList.remove('loading');
        
        // Show rolling logo in hero position
        rollingLogo.classList.add('hero-position');
        rollingLogo.style.opacity = '1';
        
        // Check if teeter animation is enabled
        if (ANIMATION_CONFIG.enableTeeterAnimation) {
            console.log('🎪 Starting teeter animation in 0.5s...');
            
            // After content is visible, trigger the teeter animation
            setTimeout(() => {
                startDropAndBounce();
            }, 500); // Wait 0.5s for content to be visible
        } else {
            console.log('⚡ Teeter animation disabled - showing final position');
            // Skip animation, go straight to final position
            setTimeout(() => {
                rollingLogo.classList.remove('hero-position');
                rollingLogo.classList.add('scrolled-position');
                initScrollBehavior();
            }, 500);
        }
        
    }, ANIMATION_CONFIG.loadingDuration); // Use configured loading duration
}

// Drop and bounce animation (HOMEPAGE ONLY)
function startDropAndBounce() {
    const rollingLogo = document.getElementById('rollingLogo');
    
    console.log('🎪 Starting teeter-and-fall animation');
    
    if (!rollingLogo) {
        console.error('❌ Rolling logo not found! Cannot animate.');
        return;
    }
    
    // CRITICAL: Ensure logo is visible
    rollingLogo.style.display = 'block';
    rollingLogo.style.visibility = 'visible';
    
    // Start the teeter and roll animation
    rollingLogo.classList.remove('hero-position');
    rollingLogo.classList.add('bouncing');
    
    console.log('   Animation running for ' + ANIMATION_CONFIG.animationDuration + 'ms...');
    
    // After animation completes, set to scrolled position and enable scroll behavior
    setTimeout(() => {
        console.log('✅ Animation complete, enabling scroll behavior');
        
        rollingLogo.classList.remove('bouncing');
        rollingLogo.classList.add('scrolled-position');
        
        // Enable scroll-based three-state behavior
        initScrollBehavior();
    }, ANIMATION_CONFIG.animationDuration); // Use configured animation duration
}

// Initialize for non-homepage pages
function initNonHomepage() {
    const body = document.body;
    const loadingScreen = document.getElementById('loadingScreen');
    const rollingLogo = document.getElementById('rollingLogo');
    
    // Hide loading screen immediately
    if (loadingScreen) {
        loadingScreen.style.display = 'none';
    }
    
    // CRITICAL: Completely hide rolling logo on non-homepage pages
    if (rollingLogo) {
        rollingLogo.style.display = 'none';
        rollingLogo.style.visibility = 'hidden';
        rollingLogo.style.opacity = '0';
    }
    
    // No scroll behavior needed on non-homepage (logo is hidden)
    // initScrollBehavior(); // Commented out - no logo to animate
}

// Skip animations and show logo immediately (for when animations are disabled)
function skipAnimationsShowLogoImmediately() {
    const body = document.body;
    const loadingScreen = document.getElementById('loadingScreen');
    const rollingLogo = document.getElementById('rollingLogo');
    
    console.log('⚡ Skipping animations - instant load');
    
    if (!rollingLogo) {
        console.error('❌ Rolling logo not found!');
        return;
    }
    
    // Hide loading screen immediately
    if (loadingScreen) {
        loadingScreen.style.display = 'none';
    }
    
    // Make sure content is visible
    body.classList.remove('loading');
    
    // Show logo immediately in final scrolled position
    rollingLogo.style.display = 'block';
    rollingLogo.style.visibility = 'visible';
    rollingLogo.classList.add('scrolled-position');
    rollingLogo.style.opacity = '1';
    
    // Enable scroll behavior immediately
    initScrollBehavior();
    
    console.log('✅ Logo shown instantly at final position');
}

// Scroll behavior - three states
function initScrollBehavior() {
    const rollingLogo = document.getElementById('rollingLogo');
    const logoNormal = document.getElementById('logoNormal');
    const logoCracked = document.getElementById('logoCracked');
    const logoSplit = document.getElementById('logoSplit');
    
    if (!rollingLogo || !logoNormal || !logoCracked || !logoSplit) return;
    
    let lastScrollTop = 0;
    let rotation = 720; // Start rotation at 720deg (where teeter-and-roll animation ends)

    window.addEventListener('scroll', () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollDelta = scrollTop - lastScrollTop;
        
        // Calculate rotation based on scroll amount
        rotation += scrollDelta * 0.5;
        
        // Get scroll percentage
        const scrollHeight = document.documentElement.scrollHeight;
        const clientHeight = document.documentElement.clientHeight;
        const scrollPercentage = (scrollTop / (scrollHeight - clientHeight)) * 100;
        
        // State 1: Normal (0-50% scroll)
        if (scrollPercentage < 98) {
            logoNormal.style.opacity = '1';
            logoCracked.style.opacity = '0';
            logoSplit.style.opacity = '0';
            logoNormal.style.transform = `rotate(${rotation}deg)`;
            rollingLogo.classList.remove('at-bottom');
            logoSplit.classList.remove('active');
        }
        // State 2: Cracked (50-80% scroll)
        else if (scrollPercentage >= 98 && scrollPercentage < 100) {
            logoNormal.style.opacity = '0';
            logoCracked.style.opacity = '1';
            logoSplit.style.opacity = '0';
            logoCracked.style.transform = `rotate(${rotation}deg)`;
            rollingLogo.classList.remove('at-bottom');
            logoSplit.classList.remove('active');
        }
        // State 3: Split (80-100% scroll)
        //else if (scrollPercentage >= 80) {
       //     logoNormal.style.opacity = '0';
       //     logoCracked.style.opacity = '0';
       //     logoSplit.style.opacity = '1';
       //     logoSplit.classList.add('active');
       //     rollingLogo.classList.add('at-bottom');
       // }
        
        lastScrollTop = scrollTop;
    });
}

// Hide scroll indicator after first scroll
function initScrollIndicator() {
    const scrollIndicator = document.querySelector('.scroll-indicator');
    
    if (!scrollIndicator) return;
    
    window.addEventListener('scroll', () => {
        if (window.pageYOffset > 100) {
            scrollIndicator.style.opacity = '0';
        } else {
            scrollIndicator.style.opacity = '1';
        }
    }, { passive: true });
}

// Form submission handling
function initFormHandling() {
    const reservationForm = document.querySelector('.reservation-form');
    
    if (!reservationForm) return;
    
    reservationForm.addEventListener('submit', (e) => {
        e.preventDefault();
        
        // In Shopify, replace this with your actual form submission logic
        // This could be a Shopify form, Klaviyo, or other service
        alert('Thanks for your interest! We\'ll get back to you soon.');
        
        // Example: You might want to collect form data
        const formData = new FormData(reservationForm);
        console.log('Form data:', Object.fromEntries(formData));
        
        // Reset form after submission
        reservationForm.reset();
    });
}

// Initialize all functions when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    console.log('🚀 Sad Friends Ceramics - Initializing...');
    console.log('🎛️ Animation Config:', ANIMATION_CONFIG.enableAnimations ? 'ENABLED ✅' : 'DISABLED ❌');
    
    // Check if we're on the homepage
    if (isHomepage()) {
        console.log('📍 On HOMEPAGE');
        
        // Check if animations are enabled
        if (ANIMATION_CONFIG.enableAnimations) {
            console.log('🎬 Running full animation sequence');
            // HOMEPAGE + ANIMATIONS ENABLED: Run full loading sequence
            initLoadingSequence();
        } else {
            console.log('⚡ Animations disabled - showing logo instantly');
            // HOMEPAGE + ANIMATIONS DISABLED: Skip to final position
            skipAnimationsShowLogoImmediately();
        }
    } else {
        console.log('📍 On OTHER PAGE - Hiding logo');
        // OTHER PAGES: Skip loading screen, hide logo
        initNonHomepage();
    }
    
    // Init other features (all pages)
    initScrollIndicator();
    initFormHandling();
    
    console.log('✅ Initialization complete');
});
